import { render, staticRenderFns } from "./TableInstrutores.vue?vue&type=template&id=69a6dd91&scoped=true"
import script from "./TableInstrutores.vue?vue&type=script&lang=js"
export * from "./TableInstrutores.vue?vue&type=script&lang=js"
import style0 from "./TableInstrutores.vue?vue&type=style&index=0&id=69a6dd91&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69a6dd91",
  null
  
)

export default component.exports